import React, { useMemo } from 'react';
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import GroupReportContext from '../../../../Context/GroupReportContext';
import { useContext } from 'react';
import { useState } from 'react';
import { initialDataLeaderShip } from '../groupReport-pdf/QuadrantInFocus';
import { useGroupReportDate } from '../../../../Context/GroupReportDate';

const PerformanceInFocus360 = ({ apiData, reportType, pageNumber }) => {
  const groupReportCtx = useContext(GroupReportContext)
  const [dynamicData, setDynamicData] = useState([...initialDataLeaderShip]);
  const {tablevaluels2: tablevaluels2Raw} =  useGroupReportDate();

  // Merge all page data into a single array
  const tablevaluels2 = useMemo(() => {
    if (!tablevaluels2Raw) return [];

    const mergedData = [];
    // Merge data from all pages (page1, page2, page3, page4)
    ['page1', 'page2', 'page3', 'page4'].forEach(pageKey => {
      if (tablevaluels2Raw[pageKey] && Array.isArray(tablevaluels2Raw[pageKey])) {
        mergedData.push(...tablevaluels2Raw[pageKey]);
      }
    });

    return mergedData;
  }, [tablevaluels2Raw]);

  const respondentName = apiData?.fullName?.split(' ')[0] || '[First Name]';
  const questions = [
    { id: 1, question: "When leading through conflict, [First Name]'s goal is to accomplish our objective by any means necessary." },
    { id: 2, question: "[First Name] is at their best when driving others to deliver results." },
    { id: 3, question: "[First Name] is motivated by organizations that prioritize measurable results." },
    { id: 4, question: "[First Name] likes the challenge of working in a high-performance leadership team." },
    { id: 5, question: "[First Name] believes great execution is primary." },
    { id: 6, question: "[First Name] is motivated to push the team to win." },
    { id: 7, question: "[First Name] has found success by outworking other people." },
    { id: 8, question: "[First Name] develops others by coaching them toward measurable results." },
    { id: 9, question: "[First Name] takes pride in superior execution." },
    { id: 10, question: "[First Name] likes to win in a competitive environment." }
  ].map(q => ({ ...q, question: q.question.replace(/\[First Name\]/g, respondentName) }));

  const styles = {
    container: { paddingTop: '16px' },
    heading: { fontSize: "14px", paddingBottom: "16px", lineHeight: "18px", fontWeight: 700, color: "#00577D", margin: 0, fontFamily: "'Helvetica', sans-serif", letterSpacing: 0 },
    description: { marginBottom: "16px", color: "#000", marginTop: 0, fontFamily: "'Helvetica', sans-serif", fontWeight: 400, fontStyle: 'normal', fontSize: '10px', lineHeight: '18px', letterSpacing: '0px' },
    tableWrapper: { overflow: "hidden", border: "0.25px solid #F1F3F3", borderRadius: "10px" },
    table: { width: "100%", borderCollapse: "separate", borderSpacing: "0", lineHeight: "13px", },
    th: { padding: "5px 12px", backgroundColor: "#245775", color: "white", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, lineHeight: "13px", fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px' },
    td: { borderLeft: "0.67px solid #ddd", padding: "5px", textAlign: "center", fontFamily: 'Helvetica', fontWeight: 400, fontStyle: 'normal', fontSize: '9px', letterSpacing: '0px', color: "#000000" },  
    strengthColumn: { width: "100%", textAlign: "left", padding: "5.5px 15px", border: "none" },
    rowEven: { backgroundColor: "#FFF" },
    rowOdd: { backgroundColor: "#F1F3F3" },
    rectangleWrapper: { display: "flex", justifyContent: "center", alignItems: "center", height: "26px", width: "25px", margin: "0 auto" },
    rectangle: { width: "16px", height: "16px", backgroundColor: "#C99212", borderRadius: "1.34px" }
  };


  const renderRectangle = (avgScore, index) => {
    const full = Math.floor(avgScore);
    const partial = avgScore - full;
    if (index + 1 < full + 1) {
      // Full square
      return <div style={styles.rectangle}></div>;
    } else if (index === full && partial > 0) {
      // Partial square (only red part, no light background)
      return (
        <div style={{ ...styles.rectangle, position: 'relative', overflow: 'hidden', backgroundColor: 'transparent' }}>
          <div style={{
            position: 'absolute',
            left: 0,
            top: 0,
            width: `${partial * 100}%`,
            height: '100%',
            backgroundColor: '#C99212',
            borderRadius: '1.34px',
            zIndex: 2,
          }}></div>
        </div>
      );
    } else {
      return null;
    }
  };

  const displayData = dynamicData
  const allMembersDataArray = Object.values(apiData?.memberResults?.allMembersData || {});
  const allVariableSets = allMembersDataArray.map(el => el.variables);
  const allAssessmentDesignation = allMembersDataArray.map(el => el.designation);
  const allAssessmentHash = allMembersDataArray.map(el => el.hash);
  const allAssessmentFullName = allMembersDataArray.map(el => el.fullName);

  const quadrantScores = {
    "PERFORMANCE": 1,
    "STRATEGIC": 2,
    "VISIONARY": 3,
    "COLLABORATIVE": 4
  }
  const allResults = [];
  displayData?.forEach((el, index) => {
    // Only process PERFORMANCE quadrant items (quadrant score 1)
    if (quadrantScores?.[el.quadrant] === 1 && tablevaluels2[index]) {
      // Get the last value from the array (index 5) which is the average score
      const averageScore = tablevaluels2[index]?.[5];
      allResults.push({
        averageScore: averageScore,
        quadrant: el.quadrant,
        no: el.no,
        ques: el?.question
      });
    }
  });


  // console.log("displayData",displayData,allResults)


  return (
    <div style={{ backgroundColor: "rgb(255, 255, 255)" }}>
      <HeaderPreview />
      <div style={styles.container}>
        <h1 style={styles.heading}>PERFORMANCE LEADERSHIP 360 IN FOCUS</h1>
        <p style={styles.description}>
          This chart isolates the items related to Performance Leadership based on the OBSERVER ratings (SELF excluded). Focused results reflect the average of observer scores only. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.
        </p>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.strengthColumn }}>Performance</th>
                <th style={{ ...styles.th }}>Score</th>
                {[1, 2, 3, 4].map((num) => (
                  <th key={num} style={styles.th}>
                    {num}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {questions.map((item, index) => {
                const avgScore = allResults[index]?.averageScore;
                return (
                  <tr
                    key={index}
                    style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}
                  >
                    <td style={{ ...styles.td, ...styles.strengthColumn }}>
                      {item.question.replace(/\[First Name\]/g, respondentName)}
                    </td>
                    <td style={{ ...styles.td }}> {parseFloat(avgScore) > 0 ? avgScore : "-"} </td>
                    {[0, 1, 2, 3].map((idx) => (
                      <td key={idx} style={styles.td}>
                        <div style={styles.rectangleWrapper}>
                          {renderRectangle(avgScore, idx)}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
      <FooterPreview pageNumber={pageNumber} reportType={reportType} />
    </div>
  );
};

export default PerformanceInFocus360;
